import { ZepIcon_default } from './chunk-SGEFWXJL.mjs';
import { jsx } from 'react/jsx-runtime';

var PlusIcon = ZepIcon_default((props) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M12 4a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0v-6H5a1 1 0 1 1 0-2h6V5a1 1 0 0 1 1-1Z",
    fill: props.fill || "currentColor"
  }
) }));

export { PlusIcon };
